import { useState, useImperativeHandle, useRef } from "react";
import { Modal, Header } from "semantic-ui-react";

import FollowupOptionsForm from "./FollowupOptionsForm";

/**
 * Options editor for a follow-up question. It stays on Semantic UI because it
 * opens over the Semantic follow-up modal, which sits above every shadcn
 * popup layer.
 */
const FollowupOptionsModal = ({ ref }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [question, setQuestion] = useState();
  const onUpdateRef = useRef();

  const handleOpen = (question, onUpdate) => {
    setQuestion(question);
    setModalOpen(true);
    onUpdateRef.current = onUpdate;
  };

  useImperativeHandle(ref, () => ({
    open: handleOpen,
  }));

  const handleClose = () => {
    setModalOpen(false);
  };

  const updateQuestion = question => {
    onUpdateRef.current(question);
  };

  return (
    <Modal
      open={modalOpen}
      onClose={handleClose}
      size="tiny"
      closeIcon
      closeOnDimmerClick={false}
    >
      <Header content="Edit Options" />
      <Modal.Content>
        <FollowupOptionsForm
          question={question}
          onSuccess={handleClose}
          updateQuestion={updateQuestion}
        />
      </Modal.Content>
    </Modal>
  );
};

export default FollowupOptionsModal;
